import React, { useState } from 'react'
import { BlockPicker, SketchPicker } from 'react-color'


const CambiarColorTexto = (props) => {

    const {
        abrirModalTexto,
        setAbrirModalTexto,
        id,
        textFill,
        setNodos,
        nodos,
        isSelected,
    } = props;


    const [color, setColor] = useState(textFill);

    const [colorFigura, setColorFigura] = useState(textFill);
    const [displayColorPicker, setDisplayColorPicker] = useState(false);

    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker);
        setAbrirModalTexto(!abrirModalTexto);
    };

    const handleClose = () => {
        setDisplayColorPicker(false);
        setAbrirModalTexto(false);
    };

    const handleChange = (color) => {
        setColorFigura(color.rgb)
        setColor(color.rgb)
    };

    const cambiarColor = (color)=> {
        setColorFigura(color.rgb)
        setColor(color.rgb)
        setNodos(
            nodos.map((nodo)=>{
                if(id === nodo.id){
                    return {
                        ...nodo,
                        isDragging: false,
                        textFill: color.hex
                    }
                }else{
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
            })
        )
    }

    return (
        <div>
            { isSelected ? 
                <div style={ {
                    position: 'absolute',
                    zIndex: '2',
                    marginTop: '100px'
                }}>
                    <div 
                        style={{
                            position: 'fixed',
                            top: '0px',
                            right: '0px',
                            bottom: '0px',
                            left: '0px',
                        }}
                        onClick={handleClose}
                    />
                    {/* <SketchPicker 
                        color={ color } 
                        onChange={ cambiarColor } 
                    /> */}
                    <BlockPicker
                        color={ color } 
                        onChange={ cambiarColor }
                        colors = {
                            ['#D9E3F0', 
                            '#F90909', 
                            '#969696', 
                            '#09F955', 
                            '#2CCCE4', 
                            '#000000', 
                            '#F9D609', 
                            '#F99709', 
                            '#D809F9']
                        }
                    />
                </div> 
            : null 
            }

        </div>
    )
}

export default CambiarColorTexto